<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center">
      <h1 class="ml-2 title font-weight-medium py-2">พนักงาน</h1>
      <div>
        <v-btn
          :disabled="
            uiCtrl && !uiCtrl.isEnable('btn:::employee_temporary:list')
          "
          @click="handleManageEmployeeDevice"
          class="text-capitalize mr-2"
          outlined
          >ลงทะเบียนที่ Device
        </v-btn>
        <v-btn
          :disabled="uiCtrl && !uiCtrl.isEnable('btn:::employee:create')"
          color="primary"
          @click="handleCreateEmployee"
        >
          <v-icon small left>mdi-plus</v-icon>เพิ่มพนักงาน
        </v-btn>
        <v-menu min-width="200">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="ml-1" icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list nav dense>
            <v-list-item
              link
              :disabled="
                uiCtrl &&
                !uiCtrl.isEnable('btn:::import_data:import_csv:employee:post')
              "
              @click="handleUploadEmployee"
            >
              <v-list-item-icon>
                <v-icon>mdi-import</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>นำเข้าข้อมูลพนักงาน</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              :disabled="
                uiCtrl &&
                !uiCtrl.isEnable('btn:::import_data:import_csv:card:post')
              "
              @click="handleUploadCard"
            >
              <v-list-item-icon>
                <v-icon>mdi-import</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>นำเข้าข้อมูลบัตร</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              :disabled="
                uiCtrl &&
                !uiCtrl.isEnable(
                  'btn:::import_data:import_csv:employee_ms_entraid_email:post'
                )
              "
              @click="handleUploadEmployeeMsEntraId"
            >
              <v-list-item-icon>
                <v-icon>mdi-import</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  นำเข้าข้อมูล MS Entra ID
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              :disabled="
                uiCtrl &&
                !uiCtrl.isEnable(
                  'btn:::import_data:import:employee_identifier:post'
                )
              "
              @click="dialogUploadProfile = true"
            >
              <v-list-item-icon>
                <v-icon>mdi-import</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>นำเข้าข้อมูลใบหน้า</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              link
              :disabled="
                uiCtrl &&
                !uiCtrl.isEnable(
                  'btn:::import_data:import:employee_biometric:post'
                )
              "
              @click="dialogImportEmployeeBiometric = true"
            >
              <v-list-item-icon>
                <v-icon>mdi-import</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>นำเข้าข้อมูลลายนิ้วมือ</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <v-tabs
      v-model="tabTableViews"
      height="42"
      background-color="transparent"
      @change="handleTabTableViews"
    >
      <v-tab>ทั้งหมด</v-tab>
      <v-tab>ข้อมูลทั่วไป</v-tab>
      <v-tab>การระบุตัวตน</v-tab>
      <v-tab>กำหนดเอง</v-tab>
      <v-menu
        offset-y
        :close-on-content-click="false"
        v-if="tabTableViews === 3"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="align-self-end ml-2 mb-1"
            outlined
            v-bind="attrs"
            v-on="on"
            small
            color="grey darken-3"
          >
            <v-icon left>mdi-format-list-checkbox</v-icon>
            คอลัมน์
          </v-btn>
        </template>
        <ul class="white pl-4 pr-6 pt-2 pb-4" style="list-style: none">
          <li v-for="item in headerCustomTableViewMenu" :key="item.text">
            <v-checkbox
              v-model="item.checked"
              dense
              hide-details
              @change="handleCustomCheckViewMenu(item)"
            >
              <template v-slot:label>
                <span style="font-size: 14px">{{ item.text }}</span>
              </template>
            </v-checkbox>
          </li>
        </ul>
      </v-menu>
    </v-tabs>
    <div class="mt-3 d-flex align-center flex-wrap" style="gap: 8px">
      <v-text-field
        v-model="search"
        class="white"
        prepend-inner-icon="mdi-magnify"
        clearable
        dense
        outlined
        hide-details
        placeholder="รหัส - ชื่อพนักงาน"
        @input="handleSearch"
        style="max-width: 248px"
      ></v-text-field>
      <v-autocomplete
        v-if="
          tabTableViews === 0 ||
          tabTableViews === 1 ||
          (tabTableViews === 3 &&
            headerCustomTableView.find(
              (h) => h.value === 'organization.title_th' && h.checked
            ))
        "
        v-model="filterOrganization"
        class="white"
        :items="organizations"
        item-text="title_th"
        item-value="organization_uuid"
        label="หน่วยงาน"
        prepend-inner-icon="mdi-filter-variant"
        clearable
        dense
        outlined
        hide-details
        @change="handleFilterOrganization"
        style="max-width: 248px"
      ></v-autocomplete>
      <v-autocomplete
        v-if="
          tabTableViews === 0 ||
          tabTableViews === 1 ||
          (tabTableViews === 3 &&
            headerCustomTableView.find(
              (h) => h.value === 'employee_type.title_th' && h.checked
            ))
        "
        v-model="filterEmployeeType"
        class="white"
        :items="employeeTypes"
        item-text="title_th"
        item-value="employee_type_uuid"
        label="ประเภทพนักงาน"
        prepend-inner-icon="mdi-filter-variant"
        clearable
        dense
        outlined
        hide-details
        @change="handleFilterEmployeeType"
        style="max-width: 248px"
      ></v-autocomplete>
      <v-autocomplete
        v-if="
          tabTableViews === 0 ||
          tabTableViews === 1 ||
          (tabTableViews === 3 &&
            headerCustomTableView.find(
              (h) => h.value === 'shift.title_th' && h.checked
            ))
        "
        v-model="filterShift"
        class="white"
        :items="shifts"
        item-text="title_th"
        item-value="shift_uuid"
        label="กะทำงาน"
        prepend-inner-icon="mdi-filter-variant"
        clearable
        dense
        outlined
        hide-details
        @change="handleFilterShift"
        style="max-width: 248px"
      ></v-autocomplete>
      <!-- <v-autocomplete
          v-if="
            tabTableViews === 0 ||
            tabTableViews === 1 ||
            (tabTableViews === 3 &&
              headerCustomTableView.find(
                (h) => h.value === 'position.title_th' && h.checked
              ))
          "
          v-model="filterPosition"
          class="white ml-2"
          :items="positions"
          item-text="title_th"
          item-value="position_uuid"
          label="ตำแหน่ง"
          prepend-inner-icon="mdi-filter-variant"
          clearable
          dense
          outlined
          hide-details
          @change="handleFilterPosition"
          style="width: 264px"
        ></v-autocomplete> -->
      <v-select
        v-if="
          tabTableViews === 0 ||
          tabTableViews === 2 ||
          (tabTableViews === 3 &&
            headerCustomTableView.find(
              (h) => h.value === 'identify_mode' && h.checked
            ))
        "
        v-model="filterIdentifyMode"
        class="white"
        :items="identifyModes"
        item-text="title_th"
        item-value="identify_mode"
        label="วิธีระบุตัวตน"
        prepend-inner-icon="mdi-filter-variant"
        clearable
        dense
        outlined
        hide-details
        @change="handleFilterIdentifyMode"
        style="max-width: 232px"
      ></v-select>
      <v-select
        v-if="
          tabTableViews === 0 ||
          tabTableViews === 1 ||
          tabTableViews === 2 ||
          (tabTableViews === 3 &&
            headerCustomTableView.find(
              (h) => h.value === 'is_active' && h.checked
            ))
        "
        v-model="filterIsActive"
        class="white"
        :items="[
          { id: 1, text: 'Active', value: true },
          { id: 2, text: 'Not Active', value: false },
          { id: 3, text: 'All Status', value: null },
        ]"
        item-text="text"
        item-value="value"
        label="สถานะพนักงาน"
        prepend-inner-icon="mdi-filter-variant"
        dense
        outlined
        hide-details
        @change="handleFilterIsActive"
        style="max-width: 232px"
      ></v-select>
    </div>
    <v-data-table
      style="width: 100%"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="loading"
      :headers="headers"
      :items="employees"
      :options.sync="options"
      :server-items-length="totalEmployees"
      :items-per-page="10"
      class="mt-2 elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
    >
      <template v-slot:item.image="{ item }">
        <v-list-item-avatar
          rounded
          size="36"
          class="my-1 mx-0"
          style="cursor: pointer"
          @click.stop="handleShowPreviewImg(item.url_photo_identifier)"
        >
          <v-img
            v-if="item.url_photo_identifier"
            :src="item.url_photo_identifier"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="blue lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-avatar v-else tile color="grey lighten-4" size="36">
            <v-icon color="grey lighten-1" large>mdi-account</v-icon>
          </v-avatar>
        </v-list-item-avatar>
      </template>
      <template v-slot:item.full_name="{ item }">
        {{ item.firstname_th }} {{ item.lastname_th }}
      </template>
      <template v-slot:item.identify_mode="{ item }">
        <div
          v-for="identify in identifyModes.filter(
            (f) => f.identify_mode === item.identify_mode
          )"
          :key="identify.identify_mode"
        >
          <v-chip color="cyan" text-color="white" small>
            {{ identify.title_th }}
          </v-chip>
        </div>
      </template>
      <template v-slot:item.face="{ item }">
        <div
          v-if="
            item.biometric &&
            item.biometric.some((s) => s.biometric_code === 'face')
          "
        >
          <div
            v-for="biometric in item.biometric
              .filter((b) => b.biometric_code === 'face')
              .map((item) => item.biometric_property)"
            :key="biometric.biometric_code"
          >
            <div v-for="item in biometric" :key="item.biometric_property_code">
              <v-avatar size="36">
                <v-img
                  :src="item.employee_biometric.file_path"
                  alt="face"
                ></v-img>
              </v-avatar>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:item.finger="{ item }">
        <div
          v-if="
            item.biometric &&
            item.biometric.some(
              (s) => s.biometric_code === 'fingerprint_secugen'
            )
          "
        >
          <div
            v-for="biometric in item.biometric
              .filter((b) => b.biometric_code === 'fingerprint_secugen')
              .map((item) => item.biometric_property)"
            :key="biometric.biometric_code"
            style="display: flex; flex-wrap: wrap"
          >
            <div
              v-for="item in biometric"
              :key="item.biometric_property_code"
              style="width: 30px; height: 30px"
            >
              <v-icon size="32">mdi-fingerprint</v-icon>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:item.time_attendance_start_time="{ item }">
        <span v-if="item.time_attendance_start_time">
          {{ item.time_attendance_start_time | dateFormat }}
        </span>
      </template>
      <template v-slot:item.time_attendance_end_time="{ item }">
        <span v-if="item.time_attendance_end_time">
          {{ item.time_attendance_end_time | dateFormat }}
        </span>
      </template>
      <template v-slot:item.last_updated="{ item }">
        <span v-if="item.last_updated">
          {{ item.last_updated | datetimeFormat }}
        </span>
      </template>
      <template v-slot:item.face_last_updated="{ item }">
        <span v-if="item.biometric">
          {{
            getBiometricLastUpdated(item.biometric, 'face')[0] | datetimeFormat
          }}
        </span>
      </template>
      <template v-slot:item.finger_last_updated="{ item }">
        <span v-if="item.biometric">
          {{
            getBiometricLastUpdated(item.biometric, 'fingerprint_secugen')[0]
              | datetimeFormat
          }}
        </span>
      </template>
      <template v-slot:item.is_active="{ item }">
        <v-chip outlined :color="item.is_active ? 'success' : 'grey'" small>
          {{ item.is_active ? 'Active' : 'Not Active' }}
        </v-chip>
      </template>
      <template v-slot:item.resign_date="{ item }">
        <span v-if="item.resign_date">
          {{ item.resign_date | dateFormat }}
        </span>
      </template>
    </v-data-table>
    <EmployeeForm
      :formShow="employeeFormShow"
      :formAction="employeeFormAction"
      :employee="employee"
      :employeeInit="employeeInit"
      @isEmployeeDataChange="handleEmployeeFormDataChange"
      @formActionCompleted="handleEmployeeFormActionCompleted"
      @onReset="handleEmployeeFormReset"
      @onClickBiometric="handleOnClickBiometric"
    />
    <EmployeeFingerFormList
      :formShow="formEmployeeFingerFormListShow"
      :employee="employee"
      :biometric="employeeFingerBiometric"
      @onClickBack="() => (formEmployeeFingerFormListShow = false)"
      @onClickAddFinger="() => (formEmployeeFingerFormAddShow = true)"
      @onClickEditFinger="handleEmployeeEditFinger"
    />
    <EmployeeFingerFormAdd
      :formShow="formEmployeeFingerFormAddShow"
      :employee="employee"
      :biometric="employeeFingerBiometric"
      @isEmployeeFingerFormDataChange="handleEmployeeFingerFormDataChange"
      @onClickBack="() => (formEmployeeFingerFormAddShow = false)"
      @submitEmployeeFingerFormAdd="handleSubmitEmployeeFingerFormAdd"
    />
    <EmployeeFingerFormEdit
      :formShow="formEmployeeFingerFormEditShow"
      :employee="employee"
      :biometric="employeeFingerBiometric"
      :biometricSelected="biometricSelected"
      @isEmployeeFingerFormDataChange="handleEmployeeFingerFormDataChange"
      @onClickBack="() => (formEmployeeFingerFormEditShow = false)"
      @submitEmployeeFingerFormEdit="handleSubmitEmployeeFingerFormEdit"
    />
    <EmployeeFaceFormList
      :formShow="formEmployeeFaceFormListShow"
      :employee="employee"
      :biometric="employeeFaceBiometric"
      @onClickBack="() => (formEmployeeFaceFormListShow = false)"
      @onClickAddFace="() => (formEmployeeFaceFormAddShow = true)"
      @onClickEditFace="handleEmployeeEditFace"
    />
    <EmployeeFaceFormAdd
      :formShow="formEmployeeFaceFormAddShow"
      :employee="employee"
      :biometric="employeeFaceBiometric"
      @isEmployeeFaceFormDataChange="handleEmployeeFaceFormDataChange"
      @onClickBack="() => (formEmployeeFaceFormAddShow = false)"
      @submitEmployeeFaceFormAdd="handleSubmitEmployeeFaceFormAdd"
    />
    <EmployeeFaceFormEdit
      :formShow="formEmployeeFaceFormEditShow"
      :employee="employee"
      :biometric="employeeFaceBiometric"
      :biometricSelected="biometricSelected"
      @isEmployeeFaceFormDataChange="handleEmployeeFaceFormDataChange"
      @onClickBack="() => (formEmployeeFaceFormEditShow = false)"
      @submitEmployeeFaceFormEdit="handleSubmitEmployeeFaceFormEdit"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="
        (employeeFormShow && employeeFormAction === 'add') ||
        formEmployeeFaceFormListShow ||
        formEmployeeFaceFormAddShow ||
        formEmployeeFaceFormEditShow ||
        formEmployeeFingerFormListShow ||
        formEmployeeFingerFormAddShow ||
        formEmployeeFingerFormEditShow
      "
      z-index="0"
    ></v-overlay>
    <UploadDialog
      :uploadDialog="uploadDialog"
      :uploadDialogTitle="uploadDialogTitle"
      :downloadExampleFileImportDataUrl="exampleFileImportDataUrl"
      :downloadExampleFileImportDataName="downloadExampleFileImportDataName"
      @selectedFile="selectedFile"
      @handleCancelUploadDialog="handleCancelUploadDialog"
      @uploadFile="uploadFile"
    />
    <UploadDialogMessage
      :uploadDialogMessage="uploadDialogMessage"
      :uploadDialogMessageTitle="uploadDialogMessageTitle"
      :downloadFileImportDataUrl="fileImportDataUrl"
      :downloadFileImportDataName="fileImportDataName"
      @onClose="uploadDialogMessage = false"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
    <DialogEmployeeDeviceList
      :dialogEmployeeDeviceList="dialogEmployeeDeviceList"
      @onCloseDialog="dialogEmployeeDeviceList = false"
    />
    <v-dialog v-model="dialogUploadProfile" persistent width="600">
      <v-card>
        <v-card-title class="text-h5 d-flex mb-1">
          <div class="flex-grow-1">นำเข้าข้อมูลใบหน้า</div>
          <div>
            <v-btn
              icon
              @click="
                () => {
                  selectFiles = null
                  files = []
                  dialogUploadProfile = false
                }
              "
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="mt-6">
          <v-file-input
            v-model="selectFiles"
            hide-details
            multiple
            label="Multiple Files"
            accept=".jpg, .jpeg"
            outlined
            dense
            @change="handleSelectFilesIdentifier"
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="
              () => {
                selectFiles = null
                files = []
                dialogUploadProfile = false
              }
            "
            :disabled="loading"
          >
            ยกเลิก
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="handleUploadEmployeeIdentifier"
            :disabled="files.length === 0"
            :loading="loading"
          >
            อัพโหลดไฟล์
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="mt-4" v-if="files.length > 0">
          <v-simple-table fixed-header height="320px" width="100%">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">ชื่อไฟล์</th>
                  <th>
                    <div class="d-flex align-center">
                      <input
                        class="mr-2"
                        type="checkbox"
                        id="identifier"
                        :checked="identifierCheckAll"
                        @change="
                          handleCheckAll($event.target.checked, 'identifier')
                        "
                      />
                      <label style="margin-top: 1px" for="identifier">
                        รูป Profile
                      </label>
                    </div>
                  </th>
                  <th>
                    <div class="d-flex align-center">
                      <input
                        class="mr-2"
                        type="checkbox"
                        id="device"
                        :checked="deviceCheckAll"
                        @change="
                          handleCheckAll($event.target.checked, 'device')
                        "
                      />
                      <label style="margin-top: 1px" for="device"
                        >Devices</label
                      >
                    </div>
                  </th>
                  <th class="text-left">สถานะอัพโหลด</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in files" :key="item.name">
                  <td>{{ item.name }}</td>
                  <td class="text-left">
                    <input type="checkbox" v-model="item.identifier" />
                  </td>
                  <td class="text-left">
                    <input type="checkbox" v-model="item.device" />
                  </td>
                  <td style="width: 20%">
                    <span v-if="item.status === 'idle'">รอดำเนินการ</span>
                    <span
                      v-else-if="item.status === 'process'"
                      class="primary--text"
                    >
                      <v-progress-circular
                        :width="2"
                        :size="24"
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </span>
                    <span
                      v-else-if="item.status === 'success'"
                      class="success--text"
                      >สำเร็จ</span
                    >
                    <span
                      v-else-if="item.status === 'error'"
                      class="error--text"
                    >
                      <v-btn
                        color="error"
                        text
                        @click="handleError(item.error)"
                      >
                        ไม่สำเร็จ
                      </v-btn>
                    </span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogImportEmployeeBiometric" persistent width="600">
      <v-card>
        <v-card-title class="text-h5 d-flex mb-1">
          <div class="flex-grow-1">นำเข้าข้อมูลลายนิ้วมือ</div>
          <div>
            <v-btn
              icon
              @click="
                () => {
                  selectFiles = null
                  files = []
                  dialogImportEmployeeBiometric = false
                }
              "
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text class="mt-6">
          <v-file-input
            v-model="selectFiles"
            hide-details
            multiple
            label="Multiple Files"
            accept=".dat, .tpl"
            outlined
            dense
            @change="handleSelectFilesBiometric"
          ></v-file-input>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            @click="
              () => {
                selectFiles = null
                files = []
                dialogImportEmployeeBiometric = false
              }
            "
            :disabled="loading"
          >
            ยกเลิก
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="handleUploadEmployeeBiometric"
            :disabled="files.length === 0"
            :loading="loading"
          >
            อัพโหลดไฟล์
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="mt-4" v-if="files.length > 0">
          <v-simple-table fixed-header height="320px" width="100%">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">ชื่อไฟล์</th>
                  <th class="text-left">สถานะอัพโหลด</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in files" :key="item.name">
                  <td>{{ item.name }}</td>
                  <td style="width: 20%">
                    <span v-if="item.status === 'idle'">รอดำเนินการ</span>
                    <span
                      v-else-if="item.status === 'process'"
                      class="primary--text"
                    >
                      <v-progress-circular
                        :width="2"
                        :size="24"
                        indeterminate
                        color="primary"
                      ></v-progress-circular>
                    </span>
                    <span
                      v-else-if="item.status === 'success'"
                      class="success--text"
                      >สำเร็จ</span
                    >
                    <span
                      v-else-if="item.status === 'error'"
                      class="error--text"
                    >
                      <v-btn
                        color="error"
                        text
                        @click="handleError(item.error)"
                      >
                        ไม่สำเร็จ
                      </v-btn>
                    </span>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogMessageError" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">Error</v-card-title>

        <v-card-text class="mt-5 error--text text-capitalize">
          {{ messageError }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogMessageError = false">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogProgress" persistent width="320">
      <div class="pa-4 white">
        <v-progress-linear :value="progressValue" height="25">
          <strong>{{ Math.ceil(progressValue) }}%</strong>
        </v-progress-linear>
      </div>
    </v-dialog>
    <v-dialog v-model="showPreviewImgDialog" width="256">
      <v-card height="308">
        <v-img
          height="256"
          width="256"
          v-if="showPreviewImgUrl"
          :src="showPreviewImgUrl"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-progress-circular
                indeterminate
                color="blue lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
        <v-avatar v-else tile color="grey lighten-4" size="256">
          <v-icon color="grey lighten-1" large>mdi-account</v-icon>
        </v-avatar>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="showPreviewImgDialog = false">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'

import ConfirmDialog from '@/components/ConfirmDialog.vue'
import DialogEmployeeDeviceList from '@/components/DialogEmployeeDeviceList.vue'
import UploadDialog from '@/components/UploadDialog.vue'
import UploadDialogMessage from '@/components/UploadDialogMessage.vue'

import EmployeeForm from '@/components/employee/EmployeeForm.vue'

import EmployeeFaceFormAdd from '@/components/employee/EmployeeFaceFormAdd.vue'
import EmployeeFaceFormEdit from '@/components/employee/EmployeeFaceFormEdit.vue'
import EmployeeFaceFormList from '@/components/employee/EmployeeFaceFormList.vue'

import EmployeeFingerFormAdd from '@/components/employee/EmployeeFingerFormAdd.vue'
import EmployeeFingerFormEdit from '@/components/employee/EmployeeFingerFormEdit.vue'
import EmployeeFingerFormList from '@/components/employee/EmployeeFingerFormList.vue'

export default {
  name: 'Employee',
  components: {
    ConfirmDialog,
    UploadDialog,
    UploadDialogMessage,
    DialogEmployeeDeviceList,
    EmployeeForm,
    EmployeeFaceFormAdd,
    EmployeeFaceFormEdit,
    EmployeeFaceFormList,
    EmployeeFingerFormAdd,
    EmployeeFingerFormEdit,
    EmployeeFingerFormList,
  },
  data() {
    return {
      tabTableViews: 0,
      selectedTableView: 'headerAllTableView',
      headerAllTableView: [
        {
          text: 'รูป',
          align: 'center',
          sortable: false,
          value: 'image',
          width: 60,
        },
        {
          text: 'รหัสพนักงาน',
          align: 'start',
          value: 'employee_code',
          class: 'text-no-wrap',
          width: 160,
        },
        {
          text: 'Serial Card',
          align: 'start',
          sortable: false,
          value: 'card_serial_number',
          class: 'text-no-wrap',
          width: 180,
        },
        {
          text: 'ชื่อ - นามสกุล',
          align: 'start',
          value: 'full_name',
          class: 'text-no-wrap',
          width: 200,
        },
        {
          text: 'หน่วยงาน',
          align: 'start',
          value: 'organization.title_th',
          class: 'text-no-wrap',
          width: 200,
        },
        {
          text: 'ตำแหน่ง',
          align: 'start',
          value: 'position.title_th',
          class: 'text-no-wrap',
          width: 200,
        },
        {
          text: 'ประเภทพนักงาน',
          align: 'start',
          value: 'employee_type.title_th',
          class: 'text-no-wrap',
          width: 200,
        },
        {
          text: 'กะทำงาน',
          align: 'start',
          value: 'shift.title_th',
          class: 'text-no-wrap',
          width: 200,
        },
        {
          text: 'วันเริ่มทำงาน',
          align: 'start',
          value: 'time_attendance_start_time',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
        },
        {
          text: 'วันสิ้นสุดอายุงาน',
          align: 'start',
          value: 'time_attendance_end_time',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
        },
        {
          text: 'วิธีระบุตัวตน',
          align: 'start',
          value: 'identify_mode',
          sortable: false,
          class: 'text-no-wrap',
          width: 200,
        },
        {
          text: 'ใบหน้า',
          align: 'start',
          value: 'face',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
        },
        {
          text: 'ลายนิ้วมือ',
          align: 'start',
          value: 'finger',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
        },
        {
          text: 'ใบหน้า อัพเดทล่าสุด',
          align: 'start',
          value: 'face_last_updated',
          sortable: false,
          class: 'text-no-wrap',
          width: 180,
        },
        {
          text: 'ลายนิ้วมือ อัพเดทล่าสุด',
          align: 'start',
          value: 'finger_last_updated',
          sortable: false,
          class: 'text-no-wrap',
          width: 180,
        },
        {
          text: 'อัพเดทล่าสุด',
          align: 'start',
          value: 'last_updated',
          sortable: false,
          class: 'text-no-wrap',
          width: 180,
        },
        {
          text: 'สถานะพนักงาน',
          align: 'start',
          value: 'is_active',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
        },
        {
          text: 'วันที่ลาออก',
          align: 'start',
          value: 'resign_date',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
        },
      ],
      headerGeneralTableView: [
        {
          text: 'รูป',
          align: 'center',
          sortable: false,
          value: 'image',
          width: 60,
        },
        {
          text: 'รหัสพนักงาน',
          align: 'start',
          value: 'employee_code',
          class: 'text-no-wrap',
          width: 160,
        },
        {
          text: 'Serial Card',
          align: 'start',
          sortable: false,
          value: 'card_serial_number',
          class: 'text-no-wrap',
          width: 180,
        },
        {
          text: 'ชื่อ - นามสกุล',
          align: 'start',
          value: 'full_name',
          class: 'text-no-wrap',
          width: 200,
        },
        {
          text: 'หน่วยงาน',
          align: 'start',
          value: 'organization.title_th',
          class: 'text-no-wrap',
          width: 200,
        },
        {
          text: 'ตำแหน่ง',
          align: 'start',
          value: 'position.title_th',
          class: 'text-no-wrap',
          width: 200,
        },
        {
          text: 'ประเภทพนักงาน',
          align: 'start',
          value: 'employee_type.title_th',
          class: 'text-no-wrap',
          width: 200,
        },
        {
          text: 'กะทำงาน',
          align: 'start',
          value: 'shift.title_th',
          class: 'text-no-wrap',
          width: 200,
        },
        {
          text: 'อัพเดทล่าสุด',
          align: 'start',
          value: 'last_updated',
          sortable: false,
          class: 'text-no-wrap',
          width: 180,
        },
        {
          text: 'สถานะพนักงาน',
          align: 'start',
          value: 'is_active',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
        },
      ],
      headerIdentityTableView: [
        {
          text: 'รูป',
          align: 'center',
          sortable: false,
          value: 'image',
          width: 60,
        },
        {
          text: 'รหัสพนักงาน',
          align: 'start',
          value: 'employee_code',
          class: 'text-no-wrap',
          width: 160,
        },
        {
          text: 'ชื่อ - นามสกุล',
          align: 'start',
          value: 'full_name',
          class: 'text-no-wrap',
          width: 200,
        },
        {
          text: 'Serial Card',
          align: 'start',
          sortable: false,
          value: 'card_serial_number',
          class: 'text-no-wrap',
          width: 180,
        },
        {
          text: 'วิธีระบุตัวตน',
          align: 'start',
          value: 'identify_mode',
          sortable: false,
          class: 'text-no-wrap',
          width: 200,
        },
        {
          text: 'ใบหน้า',
          align: 'start',
          value: 'face',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
        },
        {
          text: 'ลายนิ้วมือ',
          align: 'start',
          value: 'finger',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
        },
        {
          text: 'ใบหน้า อัพเดทล่าสุด',
          align: 'start',
          value: 'face_last_updated',
          sortable: false,
          class: 'text-no-wrap',
          width: 180,
        },
        {
          text: 'ลายนิ้วมือ อัพเดทล่าสุด',
          align: 'start',
          value: 'finger_last_updated',
          sortable: false,
          class: 'text-no-wrap',
          width: 180,
        },
        {
          text: 'สถานะพนักงาน',
          align: 'start',
          value: 'is_active',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
        },
      ],
      headerCustomTableView: [
        {
          text: 'รูป',
          align: 'center',
          sortable: false,
          value: 'image',
          width: 60,
          checked: true,
        },
        {
          text: 'รหัสพนักงาน',
          align: 'start',
          value: 'employee_code',
          class: 'text-no-wrap',
          width: 160,
          checked: true,
        },
        {
          text: 'Serial Card',
          align: 'start',
          sortable: false,
          value: 'card_serial_number',
          class: 'text-no-wrap',
          width: 180,
          checked: true,
        },
        {
          text: 'ชื่อ - นามสกุล',
          align: 'start',
          value: 'full_name',
          class: 'text-no-wrap',
          width: 200,
          checked: true,
        },
        {
          text: 'หน่วยงาน',
          align: 'start',
          value: 'organization.title_th',
          class: 'text-no-wrap',
          width: 200,
          checked: true,
        },
        {
          text: 'ตำแหน่ง',
          align: 'start',
          value: 'position.title_th',
          class: 'text-no-wrap',
          width: 200,
          checked: true,
        },
        {
          text: 'ประเภทพนักงาน',
          align: 'start',
          value: 'employee_type.title_th',
          class: 'text-no-wrap',
          width: 200,
          checked: true,
        },
        {
          text: 'กะทำงาน',
          align: 'start',
          value: 'shift.title_th',
          class: 'text-no-wrap',
          width: 200,
          checked: true,
        },
        {
          text: 'วันเริ่มทำงาน',
          align: 'start',
          value: 'time_attendance_start_time',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
          checked: true,
        },
        {
          text: 'วันสิ้นสุดอายุงาน',
          align: 'start',
          value: 'time_attendance_end_time',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
          checked: true,
        },
        {
          text: 'วิธีระบุตัวตน',
          align: 'start',
          value: 'identify_mode',
          sortable: false,
          class: 'text-no-wrap',
          width: 200,
          checked: true,
        },
        {
          text: 'ใบหน้า',
          align: 'start',
          value: 'face',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
          checked: true,
        },
        {
          text: 'ลายนิ้วมือ',
          align: 'start',
          value: 'finger',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
          checked: true,
        },
        {
          text: 'ใบหน้า อัพเดทล่าสุด',
          align: 'start',
          value: 'face_last_updated',
          sortable: false,
          class: 'text-no-wrap',
          width: 180,
          checked: true,
        },
        {
          text: 'ลายนิ้วมือ อัพเดทล่าสุด',
          align: 'start',
          value: 'finger_last_updated',
          sortable: false,
          class: 'text-no-wrap',
          width: 180,
          checked: true,
        },
        {
          text: 'อัพเดทล่าสุด',
          align: 'start',
          value: 'last_updated',
          sortable: false,
          class: 'text-no-wrap',
          width: 180,
          checked: true,
        },
        {
          text: 'สถานะพนักงาน',
          align: 'start',
          value: 'is_active',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
          checked: true,
        },
        {
          text: 'วันที่ลาออก',
          align: 'start',
          value: 'resign_date',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
          checked: true,
        },
      ],
      headerCustomTableViewMenu: [
        {
          text: 'รูป',
          align: 'center',
          sortable: false,
          value: 'image',
          width: 60,
          checked: true,
        },
        {
          text: 'รหัสพนักงาน',
          align: 'start',
          value: 'employee_code',
          class: 'text-no-wrap',
          width: 160,
          checked: true,
        },
        {
          text: 'Serial Card',
          align: 'start',
          sortable: false,
          value: 'card_serial_number',
          class: 'text-no-wrap',
          width: 180,
          checked: true,
        },
        {
          text: 'ชื่อ - นามสกุล',
          align: 'start',
          value: 'full_name',
          class: 'text-no-wrap',
          width: 200,
          checked: true,
        },
        {
          text: 'หน่วยงาน',
          align: 'start',
          value: 'organization.title_th',
          class: 'text-no-wrap',
          width: 200,
          checked: true,
        },
        {
          text: 'ตำแหน่ง',
          align: 'start',
          value: 'position.title_th',
          class: 'text-no-wrap',
          width: 200,
          checked: true,
        },
        {
          text: 'ประเภทพนักงาน',
          align: 'start',
          value: 'employee_type.title_th',
          class: 'text-no-wrap',
          width: 200,
          checked: true,
        },
        {
          text: 'กะทำงาน',
          align: 'start',
          value: 'shift.title_th',
          class: 'text-no-wrap',
          width: 200,
          checked: true,
        },
        {
          text: 'วันเริ่มทำงาน',
          align: 'start',
          value: 'time_attendance_start_time',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
          checked: true,
        },
        {
          text: 'วันสิ้นสุดอายุงาน',
          align: 'start',
          value: 'time_attendance_end_time',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
          checked: true,
        },
        {
          text: 'วิธีระบุตัวตน',
          align: 'start',
          value: 'identify_mode',
          sortable: false,
          class: 'text-no-wrap',
          width: 200,
          checked: true,
        },
        {
          text: 'ใบหน้า',
          align: 'start',
          value: 'face',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
          checked: true,
        },
        {
          text: 'ลายนิ้วมือ',
          align: 'start',
          value: 'finger',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
          checked: true,
        },
        {
          text: 'ใบหน้า อัพเดทล่าสุด',
          align: 'start',
          value: 'face_last_updated',
          sortable: false,
          class: 'text-no-wrap',
          width: 180,
          checked: true,
        },
        {
          text: 'ลายนิ้วมือ อัพเดทล่าสุด',
          align: 'start',
          value: 'finger_last_updated',
          sortable: false,
          class: 'text-no-wrap',
          width: 180,
          checked: true,
        },
        {
          text: 'อัพเดทล่าสุด',
          align: 'start',
          value: 'last_updated',
          sortable: false,
          class: 'text-no-wrap',
          width: 180,
          checked: true,
        },
        {
          text: 'สถานะพนักงาน',
          align: 'start',
          value: 'is_active',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
          checked: true,
        },
        {
          text: 'วันที่ลาออก',
          align: 'start',
          value: 'resign_date',
          sortable: false,
          class: 'text-no-wrap',
          width: 120,
          checked: true,
        },
      ],
      employeeFormShow: false,
      employeeFormAction: 'add',
      employee: {
        biometric: [],
        card: {},
      },
      employeeInit: {
        biometric: [],
        card: {},
      },
      options: {},
      sortBy: ['employee_code'],
      sortDesc: [false],
      loading: false,
      search: '',
      filterOrganization: null,
      filterPosition: null,
      filterEmployeeType: null,
      filterShift: null,
      filterIsActive: true,
      filterIdentifyMode: null,
      uploadFileType: '',
      uploadDialog: false,
      uploadDialogTitle: '',
      exampleFileImportDataUrl: '',
      downloadExampleFileImportDataName: '',
      currentFile: null,
      uploadDialogMessage: false,
      uploadDialogMessageTitle: '',
      fileImportDataUrl: '',
      fileImportDataName: '',
      dialogForbidden: false,
      dialogEmployeeDeviceList: false,
      dialogProgress: false,
      progressValue: 0,
      dialogMessageError: false,
      messageError: '',
      dialogUploadProfile: false,
      dialogImportEmployeeBiometric: false,
      selectFiles: [],
      files: [],
      biometricSelected: {},
      employeeFaceBiometric: {},
      employeeFingerBiometric: {},
      formEmployeeFaceFormListShow: false,
      formEmployeeFaceFormAddShow: false,
      formEmployeeFaceFormEditShow: false,
      formEmployeeFingerFormListShow: false,
      formEmployeeFingerFormAddShow: false,
      formEmployeeFingerFormEditShow: false,
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      timeout: null,
      isEmployeeDataChange: false,
      isEmployeeFaceFormDataChange: false,
      isEmployeeFingerFormDataChange: false,
      showPreviewImgDialog: false,
      showPreviewImgUrl: '',
    }
  },
  watch: {
    options: {
      handler() {
        this.getEmployees()
      },
      deep: true,
    },
    user() {
      const userConfig = localStorage.getItem(this.user.uuid)
      const menuEmployee = userConfig
        ? JSON.parse(userConfig)['menu-employee']
        : null
      if (menuEmployee) {
        this.tabTableViews = menuEmployee.tabTableViews
        this.handleTabTableViews(menuEmployee.tabTableViews)
        this.headerCustomTableView = this.headerCustomTableView.filter((h) => {
          const match = menuEmployee.tabCustomView.find(
            (c) => c.value === h.value
          )
          return match?.checked
        })
        this.headerCustomTableViewMenu = [...menuEmployee.tabCustomView]
      }
    },
  },
  filters: {
    dateFormat: function (value) {
      return moment(value).format('DD/MM/YYYY')
    },
    datetimeFormat: function (value) {
      if (!value) return ''
      return moment(value).format('DD/MM/YYYY HH:mm:ss')
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    user() {
      return this.$store.state.authentication.user
    },
    headers() {
      return this[this.selectedTableView]
    },
    identifierCheckAll() {
      return !!this.files.some((el) => el.identifier)
    },
    deviceCheckAll() {
      return !!this.files.some((el) => el.device)
    },
    employees() {
      return this.$store.state.employee.employees
    },
    totalEmployees() {
      return this.$store.state.employee.totalEmployees
    },
    organizations() {
      return this.$store.state.organization.organizations
    },
    employeeTypes() {
      return this.$store.state.employeeType.employeeTypes
    },
    shifts() {
      return this.$store.state.shift.shifts
    },
    positions() {
      return this.$store.state.position.positions
    },
    identifyModes() {
      return this.$store.state.hardware.identifyModes
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'พนักงาน',
        disabled: true,
      },
    ])

    if (this.user) {
      const userConfig = localStorage.getItem(this.user.uuid)
      const menuEmployee = userConfig
        ? JSON.parse(userConfig)['menu-employee']
        : null
      if (menuEmployee) {
        this.tabTableViews = menuEmployee.tabTableViews
        this.handleTabTableViews(menuEmployee.tabTableViews)
        this.headerCustomTableView = this.headerCustomTableView.filter((h) => {
          const match = menuEmployee.tabCustomView.find(
            (c) => c.value === h.value
          )
          return match?.checked
        })
        this.headerCustomTableViewMenu = [...menuEmployee.tabCustomView]
      }
    }

    const { company_uuid } = this.$store.state.authentication.company

    const organizations = this.fetchOrganizations({
      company_uuid,
      params: {
        dpc: 'employee-to-list-organization-no-filter',
        field: 'organization_uuid,organization_code,title_th',
      },
    })
    const positions = this.fetchPositions({
      company_uuid,
      params: { dpc: 'employee-to-list-position-no-filter' },
    })
    const employeeLevels = this.fetchEmployeeLevels({
      company_uuid,
      params: { dpc: 'employee-to-list-employee-level' },
    })

    const downloadExampleFileImportDataEmployee =
      this.downloadExampleFileImportData({
        uuid: company_uuid,
        exampleFileType: 'employee',
      })
    const downloadExampleFileImportDataCard =
      this.downloadExampleFileImportData({
        uuid: company_uuid,
        exampleFileType: 'card',
      })
    const downloadExampleFileImportDataMsEntraId =
      this.downloadExampleFileImportData({
        uuid: company_uuid,
        exampleFileType: 'employee/ms-entraid-email',
      })

    const fetchIdentifyModes = this.fetchIdentifyModes()
    const fetchCompany = this.fetchCompany(company_uuid)

    const biometrics = this.fetchBiometrics()

    const employeeTypes = this.fetchEmployeeTypes({
      company_uuid,
      params: { dpc: 'employee-to-list-employee-type' },
    })
    const shifts = this.fetchShifts({
      company_uuid,
      params: { dpc: 'employee-to-list-shift' },
    })
    const genders = this.fetchGenders()
    const prefixs = this.fetchPrefixs({
      company_uuid,
      params: { dpc: 'employee-to-list-employee-prefix' },
    })
    const role = this.fetchRoles({
      companyUuid: company_uuid,
      roleType: 'employee',
    })
    const accessAuthorities = this.fetchAccessAuthorities({
      company_uuid,
      params: { dpc: 'employee-temporary-to-list-authority' },
    })

    this.loading = true

    Promise.all([
      organizations,
      positions,
      employeeLevels,
      downloadExampleFileImportDataEmployee,
      downloadExampleFileImportDataCard,
      downloadExampleFileImportDataMsEntraId,
      fetchIdentifyModes,
      fetchCompany,
      biometrics,
      employeeTypes,
      shifts,
      genders,
      prefixs,
      role,
      accessAuthorities,
    ])
      .then((data) => {
        this.exampleFileImportDataUrlEmployee = data[3]
        this.exampleFileImportDataUrlCard = data[4]
        this.exampleFileImportDataUrlMsEntraId = data[5]
        this.loading = false
      })
      .catch((error) => {
        this.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
  },
  methods: {
    ...mapActions({
      fetchEmployee: 'employee/fetchEmployee',
      fetchEmployees: 'employee/fetchEmployees',
      fetchOrganizations: 'organization/fetchOrganizations',
      fetchPositions: 'position/fetchPositions',
      fetchEmployeeLevels: 'employeeLevel/fetchEmployeeLevels',
      uploadFileImportData: 'upload/uploadFileImportData',
      downloadExampleFileImportData: 'download/downloadExampleFileImportData',
      importEmployeeIdentifier: 'employee/importEmployeeIdentifier',
      importEmployeeBiometric: 'employee/importEmployeeBiometric',
      fetchIdentifyModes: 'hardware/fetchIdentifyModes',
      fetchCompany: 'company/fetchCompany',
      fetchBiometrics: 'employee/fetchBiometrics',
      fetchEmployeeTypes: 'employeeType/fetchEmployeeTypes',
      fetchShifts: 'shift/fetchShifts',
      fetchGenders: 'gender/fetchGenders',
      fetchPrefixs: 'prefix/fetchPrefixs',
      fetchRoles: 'role/fetchRoles',
      fetchAccessAuthorities: 'accessAuthority/fetchAccessAuthorities',
    }),
    getBiometricLastUpdated(items, code) {
      const biometric = items.find((b) => b.biometric_code === code)
      if (!biometric) return []
      return biometric.biometric_property
        .map((p) => p.employee_biometric?.last_updated)
        .filter(Boolean)
    },
    handleShowPreviewImg(url) {
      if (url) {
        this.showPreviewImgUrl = url
      } else {
        this.showPreviewImgUrl = ''
      }
      this.showPreviewImgDialog = true
    },
    handleSubmitEmployeeFaceFormAdd(faceData) {
      const employeeBiometric = this.$store.state.employee.employeeBiometric
      const index = employeeBiometric.findIndex(
        (eb) => eb.biometric_code === faceData.biometric_code
      )
      if (index !== -1) {
        employeeBiometric.splice(index, 1)
      }

      this.$store.commit('employee/SET_EMPLOYEE_BIOMETRIC', [
        ...employeeBiometric,
        { ...faceData },
      ])

      this.formEmployeeFaceFormAddShow = false
    },
    handleSubmitEmployeeFaceFormEdit(faceData) {
      const employeeBiometric = this.$store.state.employee.employeeBiometric
      const index = employeeBiometric.findIndex(
        (eb) => eb.biometric_code === faceData.biometric_code
      )

      if (index !== -1) {
        employeeBiometric.splice(index, 1)
      }

      this.$store.commit('employee/SET_EMPLOYEE_BIOMETRIC', [
        ...employeeBiometric,
        { ...faceData },
      ])

      this.formEmployeeFaceFormEditShow = false
    },
    handleSubmitEmployeeFingerFormAdd(fingerData) {
      const employeeBiometric = this.$store.state.employee.employeeBiometric
      const index = employeeBiometric.findIndex(
        (eb) => eb.biometric_code === fingerData.biometric_code
      )
      if (index !== -1) {
        employeeBiometric.splice(index, 1)
      }

      this.$store.commit('employee/SET_EMPLOYEE_BIOMETRIC', [
        ...employeeBiometric,
        { ...fingerData },
      ])

      this.formEmployeeFingerFormAddShow = false
    },
    handleSubmitEmployeeFingerFormEdit(fingerData) {
      const employeeBiometric = this.$store.state.employee.employeeBiometric
      const index = employeeBiometric.findIndex(
        (eb) => eb.biometric_code === fingerData.biometric_code
      )

      if (index !== -1) {
        employeeBiometric.splice(index, 1)
      }

      this.$store.commit('employee/SET_EMPLOYEE_BIOMETRIC', [
        ...employeeBiometric,
        { ...fingerData },
      ])

      this.formEmployeeFingerFormEditShow = false
    },
    handleEmployeeFormReset(formAction) {
      this.employee = {
        biometric: [],
        card: {},
      }
      this.employeeInit = {
        biometric: [],
        card: {},
      }

      this.$store.commit('employee/SET_EMPLOYEE_BIOMETRIC', [])

      this.employeeFormShow = false
      this.employeeFormAction = ''
    },
    handleEmployeeFormActionCompleted(formAction) {
      this.employee = {
        biometric: [],
        card: {},
      }
      this.employeeInit = {
        biometric: [],
        card: {},
      }

      this.$store.commit('employee/SET_EMPLOYEE_BIOMETRIC', [])

      this.employeeFormShow = false
      this.employeeFormAction = ''

      // this.search = ''

      this.isEmployeeDataChange = false
      this.isEmployeeFaceFormDataChange = false
      this.isEmployeeFingerFormDataChange = false

      this.getEmployees()
    },
    handleEmployeeFormDataChange(value) {
      this.isEmployeeDataChange = value
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    handleCreateEmployee() {
      this.employeeFormShow = true
      this.employeeFormAction = 'add'
      this.employee = {
        is_active: true,
        biometric: [],
        card: {},
      }
      this.employeeInit = {
        biometric: [],
        card: {},
        is_active: true,
      }
      this.$store.commit('employee/SET_EMPLOYEE_BIOMETRIC', [])
    },
    handleManageEmployeeDevice() {
      this.dialogEmployeeDeviceList = true
    },
    handleEmployeeFingerFormDataChange(value) {
      this.isEmployeeFingerFormDataChange = value
    },
    handleEmployeeFaceFormDataChange(value) {
      this.isEmployeeFaceFormDataChange = value
    },
    handleEmployeeEditFinger(selectedFinger) {
      this.biometricSelected = { ...selectedFinger }
      this.formEmployeeFingerFormEditShow = true
    },
    handleEmployeeEditFace(biometric) {
      this.biometricSelected = biometric
      this.formEmployeeFaceFormEditShow = true
    },
    handleTabTableViews(value) {
      if (value === 0) {
        this.selectedTableView = 'headerAllTableView'
      }

      if (value === 1) {
        this.selectedTableView = 'headerGeneralTableView'
      }

      if (value === 2) {
        this.selectedTableView = 'headerIdentityTableView'
      }

      if (value === 3) {
        this.selectedTableView = 'headerCustomTableView'
      }

      if (this.user) {
        const userConfig = localStorage.getItem(this.user.uuid)
        const menuDownloadTransaction = userConfig
          ? JSON.parse(userConfig)['menu-download-transaction']
          : null

        const config = {
          ['menu-download-transaction']: menuDownloadTransaction
            ? menuDownloadTransaction
            : undefined,
          ['menu-employee']: {
            tabTableViews: this.tabTableViews,
            tabCustomView: this.headerCustomTableViewMenu,
          },
        }

        localStorage.setItem(this.user.uuid, JSON.stringify(config))
      }
    },
    handleCustomCheckViewMenu(item) {
      if (item.checked === false) {
        this.headerCustomTableView = this.headerCustomTableView.filter(
          (header) => header.text !== item.text
        )
      } else {
        this.headerCustomTableView.push(item)
      }

      if (this.user) {
        const userConfig = localStorage.getItem(this.user.uuid)
        const menuDownloadTransaction = userConfig
          ? JSON.parse(userConfig)['menu-download-transaction']
          : null

        const config = {
          ['menu-download-transaction']: menuDownloadTransaction
            ? menuDownloadTransaction
            : undefined,
          ['menu-employee']: {
            tabTableViews: this.tabTableViews,
            tabCustomView: this.headerCustomTableViewMenu,
          },
        }

        localStorage.setItem(this.user.uuid, JSON.stringify(config))
      }
    },
    handleSearch() {
      this.loading = true
      this.getEmployeesBySearch()
    },
    getEmployeesBySearch: _.debounce(function () {
      this.options.page = 1
      this.getEmployees()
    }, 1000),
    handleFilterOrganization() {
      this.options.page = 1
      this.getEmployees()
    },
    handleFilterPosition() {
      this.options.page = 1
      this.getEmployees()
    },
    handleFilterEmployeeType() {
      this.options.page = 1
      this.getEmployees()
    },
    handleFilterShift() {
      this.options.page = 1
      this.getEmployees()
    },
    handleFilterIsActive() {
      this.options.page = 1
      this.getEmployees()
    },
    handleFilterIdentifyMode() {
      this.options.page = 1
      this.getEmployees()
    },
    async getEmployees() {
      try {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options

        const sortKey = [...sortBy]

        if (sortKey[0] === 'full_name') {
          sortKey[0] = 'firstname_th'
        }

        const sortParams = sortKey
          .map((field, i) => `${field}:${sortDesc[i] ? 'desc' : 'asc'}`)
          .join(',')

        if (this.cancelTokenSource) {
          this.cancelTokenSource.abort()
        }

        const controller = new AbortController()
        this.cancelTokenSource = controller

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            dpc: 'employee-to-list-employee',
            search: this.search || undefined,
            organization_uuid: this.filterOrganization || undefined,
            position_uuid: this.filterPosition || undefined,
            employee_type_uuid: this.filterEmployeeType || undefined,
            shift_uuid: this.filterShift || undefined,
            is_active:
              this.filterIsActive || this.filterIsActive === false
                ? this.filterIsActive
                : undefined,
            identify_mode:
              this.filterIdentifyMode || this.filterIdentifyMode === 0
                ? this.filterIdentifyMode
                : undefined,
            sort: sortParams || undefined,
            limit: itemsPerPage,
            offset: (page - 1) * itemsPerPage,
          },
          signal: controller.signal,
        }

        this.loading = true
        await this.fetchEmployees(payload)
        this.loading = false
      } catch (error) {
        if (error.name === 'CanceledError') {
          // Request was cancelled, do nothing
          return
        }

        this.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    selectedFile(file) {
      this.currentFile = file
    },
    handleCancelUploadDialog(refs) {
      this.uploadDialog = false
      this.currentFile = null
      refs.clearableCallback()
    },
    uploadFile(refs) {
      if (this.currentFile) {
        let formData = new FormData()
        formData.append('file', this.currentFile)

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          uuid: company_uuid,
          fileType: this.uploadFileType,
          formData: formData,
        }

        this.$store.state.loading = true

        this.uploadFileImportData(payload)
          .then((data) => {
            this.$store.state.loading = false
            this.uploadDialog = false
            refs.clearableCallback()

            this.progressValue = 0
            this.dialogProgress = true
            this.uploadProgress(data.job_process_uuid, data.ping_after_ms)
          })
          .catch((error) => {
            this.$store.state.loading = false
            this.uploadDialog = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      } else {
        const snackbar = {
          show: true,
          color: 'warning',
          timeout: 4000,
          message: 'ไม่ได้เลือกไฟล์ใด',
        }

        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleUploadCard() {
      this.uploadFileType = 'card'
      this.uploadDialog = true
      this.uploadDialogTitle = 'นำเข้าข้อมูลบัตร'
      this.exampleFileImportDataUrl = this.exampleFileImportDataUrlCard
      this.downloadExampleFileImportDataName = 'card.csv'
    },
    handleUploadEmployeeMsEntraId() {
      this.uploadFileType = 'employee/ms-entraid-email'
      this.uploadDialog = true
      this.uploadDialogTitle = 'นำเข้าข้อมูล MS Entra ID'
      this.exampleFileImportDataUrl = this.exampleFileImportDataUrlMsEntraId
      this.downloadExampleFileImportDataName = 'ms-entraid-email.csv'
    },
    handleUploadEmployee() {
      this.uploadFileType = 'employee'
      this.uploadDialog = true
      this.uploadDialogTitle = 'นำเข้าข้อมูลพนักงาน'
      this.exampleFileImportDataUrl = this.exampleFileImportDataUrlEmployee
      this.downloadExampleFileImportDataName = 'employee.csv'
    },
    handleSelectFilesIdentifier() {
      this.files = []
      this.selectFiles.forEach((file, index) => {
        this.files.push({
          id: index + 1,
          name: file.name,
          identifier: true,
          device: true,
          status: 'idle',
          error: null,
          file,
        })
      })
    },
    handleSelectFilesBiometric() {
      this.files = []
      this.selectFiles.forEach((file, index) => {
        this.files.push({
          id: index + 1,
          name: file.name,
          device: true,
          status: 'idle',
          error: null,
          file,
        })
      })
    },
    handleCheckAll(checked, key) {
      this.files = this.files.map((element) => ({
        ...element,
        [key]: checked,
      }))
    },
    handleError(error) {
      this.dialogMessageError = true
      this.messageError = error
    },
    async handleUploadEmployeeIdentifier() {
      this.loading = true

      this.files = this.files.map((element) => {
        return { ...element, status: 'process' }
      })

      for (const file of this.files) {
        let formData = new FormData()
        formData.append('file', file.file)
        formData.append('photo_identifier', file.identifier)
        formData.append('face', file.device)

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          formData,
        }

        try {
          await this.importEmployeeIdentifier(payload)

          this.files = this.files.map((element) => {
            if (file.id === element.id) {
              return { ...element, status: 'success' }
            } else {
              return { ...element }
            }
          })
        } catch (error) {
          this.files = this.files.map((element) => {
            if (file.id === element.id) {
              return {
                ...element,
                status: 'error',
                error:
                  error?.response?.data?.message || 'Something went wrong.',
              }
            } else {
              return { ...element }
            }
          })
        }
      }

      this.loading = false
    },
    async handleUploadEmployeeBiometric() {
      this.loading = true

      this.files = this.files.map((element) => {
        return { ...element, status: 'process' }
      })

      for (const file of this.files) {
        let formData = new FormData()
        formData.append('file', file.file)
        formData.append('fingerprint_secugen', true)

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          formData,
        }

        try {
          await this.importEmployeeBiometric(payload)

          this.files = this.files.map((element) => {
            if (file.id === element.id) {
              return { ...element, status: 'success' }
            } else {
              return { ...element }
            }
          })
        } catch (error) {
          this.files = this.files.map((element) => {
            if (file.id === element.id) {
              return {
                ...element,
                status: 'error',
                error:
                  error?.response?.data?.message || 'Something went wrong.',
              }
            } else {
              return { ...element }
            }
          })
        }
      }

      this.loading = false
    },
    classRowSelected(row) {
      if (this.employee.employee_uuid === row.employee_uuid)
        return 'row-selected'
    },
    async setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::employee:get')) {
        this.dialogForbidden = true
        return
      }

      try {
        const payload = {
          company_uuid: this.$store.state.authentication.company.company_uuid,
          employee_uuid: row.employee_uuid,
        }

        await this.fetchEmployee(payload)
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.dialogForbidden = true
        } else {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }

        return
      }

      row.organization_uuid = row.organization.organization_uuid
      row.position_uuid = row.position.position_uuid
      row.employee_level_uuid = row.employee_level?.employee_level_uuid || null
      row.employee_type_uuid = row.employee_type.employee_type_uuid
      row.shift_uuid = row.shift.shift_uuid
      row.company_prefix_uuid = row.company_prefix?.company_prefix_uuid
      row.gender_id = row.gender?.gender_id
      row.birthday = row.birthday ? new Date(row.birthday) : ''
      row.resign_date = row.resign_date ? new Date(row.resign_date) : ''
      row.time_attendance_start_time = row.time_attendance_start_time
        ? new Date(row.time_attendance_start_time)
        : ''
      row.time_attendance_end_time = row.time_attendance_end_time
        ? new Date(row.time_attendance_end_time)
        : ''

      if (this.employee.employee_uuid === row.employee_uuid) {
        this.employeeFormShow = false
        this.employeeFormAction = ''
        this.employee = {
          biometric: [],
          card: {},
        }
        this.employeeInit = {
          biometric: [],
          card: {},
        }
        this.$store.commit('employee/SET_EMPLOYEE_BIOMETRIC', [])
      } else {
        this.employeeFormShow = true
        this.employeeFormAction = 'edit'
        this.employee = {
          ...row,
          card: {
            card_uuid: row?.card[0]?.card_uuid,
            sn: row?.card_serial_number,
          },
        }
        this.employeeInit = {
          ...row,
          card: {
            card_uuid: row?.card[0]?.card_uuid,
            sn: row?.card_serial_number,
          },
        }

        const employeeBiometric = row.biometric.map((bio) => ({
          ...bio,
        }))

        this.$store.commit('employee/SET_EMPLOYEE_BIOMETRIC', employeeBiometric)

        this.isEmployeeDataChange = false
        this.isEmployeeFaceFormDataChange = false
        this.isEmployeeFingerFormDataChange = false
      }
    },
    handleRowSelected(row) {
      if (
        this.isEmployeeDataChange ||
        this.isEmployeeFaceFormDataChange ||
        this.isEmployeeFingerFormDataChange
      ) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleOnClickBiometric(biometric) {
      if (biometric?.biometric_code === 'fingerprint_secugen') {
        this.formEmployeeFingerFormListShow = true
        this.employeeFingerBiometric = biometric
      }

      if (biometric?.biometric_code === 'iris_pixer') {
        //
      }

      if (biometric?.biometric_code === 'face') {
        this.formEmployeeFaceFormListShow = true
        this.employeeFaceBiometric = biometric
      }
    },
    nextRoute(next) {
      this.formEmployeeFaceFormListShow = false
      this.formEmployeeFingerFormListShow = false
      if (this.employeeFormShow) this.employeeFormShow = false
      if (this.formEmployeeFaceFormAddShow) {
        this.formEmployeeFaceFormListShow = false
        this.formEmployeeFaceFormAddShow = false
      }
      if (this.formEmployeeFingerFormAddShow) {
        this.formEmployeeFingerFormListShow = false
        this.formEmployeeFingerFormAddShow = false
      }
      if (this.formEmployeeFaceFormEditShow) {
        this.formEmployeeFaceFormListShow = false
        this.formEmployeeFaceFormEditShow = false
      }
      if (this.formEmployeeFingerFormEditShow) {
        this.formEmployeeFingerFormListShow = false
        this.formEmployeeFingerFormEditShow = false
      }

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.isEmployeeDataChange ||
      this.isEmployeeFaceFormDataChange ||
      this.isEmployeeFingerFormDataChange
    ) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>
